import { useRef } from 'react';
import GallerySection from '@alltrails/amplitude/enums/GallerySection';
import TrailDetailsPhotoSource from '@alltrails/amplitude/enums/TrailDetailsPhotoSource';
import logTrailDetailsDistinctTrailPhotosViewed from '@alltrails/amplitude/events/logTrailDetailsDistinctTrailPhotosViewed';
import type { TrailId } from '@alltrails/types/TrailId';

type Args = {
  source: TrailDetailsPhotoSource;
  trailId: TrailId;
  gallerySection?: GallerySection;
};

export default function useTrailAggregatePhotoViewed(args?: Args): [(photoId: number) => void, () => void] {
  const photosViewedCount = useRef(0);
  const uniquePhotos = useRef(new Set<number>());

  const onPhotoViewed = (photoId: number) => {
    if (!uniquePhotos.current.has(photoId)) {
      photosViewedCount.current += 1;
      uniquePhotos.current.add(photoId);
    }
  };

  const onViewingComplete = () => {
    if (args) {
      logTrailDetailsDistinctTrailPhotosViewed({
        distinct_photos_viewed: photosViewedCount.current,
        source: args.source,
        trail_id: args.trailId,
        gallerysection: args.gallerySection
      });
    }

    uniquePhotos.current.clear();
    photosViewedCount.current = 0;
  };

  return [onPhotoViewed, onViewingComplete];
}
